module.exports = __webpack_public_path__ + "static/media/project-goals.9da4b49e.jpg";